import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-pop-terms',
  templateUrl: './pop-terms.component.html',
  styleUrls: ['./pop-terms.component.sass']
})
export class PopTermsComponent implements OnInit {
  public message: string = '';
  public title: boolean = true;
  public labelTitle: string = 'Aviso';
  public labelTitleHtml: string='';
  public menssageError: string='';
  public messageHtml: boolean = false;
  public labelContinue: string='';
  public labelCancel: string='';
  public labelPrint: string='';
  public contentHtml: string='';
  public btm:boolean=false;
  public btmPrint:boolean=true;
  constructor(public matDialogRef: MatDialogRef<PopTermsComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router) {

    if (data.title != undefined) {
      this.title = data.title;
    }
    if (data.btm != undefined) {
      this.btm = data.btm;
    }
    if (data.labelPrint != undefined) {
      this.labelPrint = data.labelPrint;
    }
    if (data.labelCancel != undefined) {
      this.labelCancel = data.labelCancel;
    }
    if (data.labelContinue != undefined) {
      this.labelContinue = data.labelContinue;
    }
    if (data.labelTitle != undefined) {
      this.labelTitle = data.labelTitle;
    }
    if (data.labelTitleHtml != undefined) {
      this.labelTitleHtml = data.labelTitleHtml;
    }
    if (data.message != undefined) {
      this.message = data.message;
    }
    if (data.contentHtml != undefined) {
      this.contentHtml = data.contentHtml;
    }
    if (data.menssageError != undefined) {
      this.menssageError = data.menssageError;
    }
    if (data.btmPrint != undefined) {
      this.btmPrint = data.btmPrint;
    }
  }
  ngOnInit() { }
  continue() {
    this.matDialogRef.close('continue');
  }
  cancel() {
    this.matDialogRef.close('cancel');
  }
  print() {
    this.matDialogRef.close('print');
  }
  close(){
    this.matDialogRef.close();
  }
}
